// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"55":"99a5daea","453":"43a3139f"}[chunkId] + ".chunk.js";
};